import { getEnvs } from '@/shared/utils';
const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTER_PATHS, hasAllPermissions, hasPermission, plantillaExcelENUM, useCheckPermissions, useTableFilter, useUploadFile } from '@/shared';
import { useFetchRadioBases, useUpdateRadioBase } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { RadioBase } from '@/shared/interfaces/erp/mantenimiento-operaciones';

const returnUrl = ROUTER_PATHS.mantenimientoOperaciones.radioBasesNav;

export interface RadioBasesPageInterface { }

const RadioBasesPage: React.FC<RadioBasesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_radiobase)

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: RadioBasesPagingRes,
    isLoading,
    isRefetching,
    refetch,
  } = useFetchRadioBases({
    page: pageIndex + 1,
    nombre: searchTerm,
  });

  ///* mutations
  const updSate = useUpdateRadioBase({
    enableRedirect: false,
    onSuccess: () => refetch(),
  });
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* handlers
  const onEdit = (original: RadioBase) => {
    navigate(`${returnUrl}/editar/${original.id_radiobase}`);
  };
  ///* columns
  const columns = useMemo<MRT_ColumnDef<RadioBase>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 200,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'direccion',
        header: 'direccion',
        size: 300,
      },
      {
        accessorKey: 'coordenadas',
        header: 'coordenadas',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_radiobase)) return;
                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de este nodo ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_radiobase!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );

  const {
    fileInputRef,
    handleImportarExcelRadioBase
  } = useUploadFile();

  return (
    <SingleTableBoxScene title="Radio base"
      urlRedirect={`${returnUrl}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_radiobase)}
      enableUploadFile={true}
      fileInputRef={fileInputRef}
      handleFileUpload={handleImportarExcelRadioBase}
      urlDownloadPlantilla={"/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_RADIO_BASE}
      urlDownloadNameExcel='plantilla_radio_base'

    >
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Radio base" />

      <GeneralTable<RadioBase>
        columns={columns}
        data={RadioBasesPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={RadioBasesPagingRes?.data?.count}
        // // actions
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_radiobase,
        ])}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_radiobase
        ])}
        // crud
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default RadioBasesPage;
